const LAWFIRM_DETAIL_TEMPLATE = {
  displayMode: {
    name: {
      displayStyle: "text",
      label: "Name",
      modelKey: "name",
      display: false,
    },

    entities: {
      displayStyle: "chip",
      label: "Entity Types",
      placeholder: "Select the entities associated with the law firm",
      required: false,
      url: "entities/",
      valueKey: "id",
      labelKey: "name",
      availableInModel: true,
      modelKey: "entities",
      modelValueKey: "entityType",
      modelValueLabel: "entityTypeLabel",
      multiple: true,
      display: false,
    },

    address: {
      displayStyle: "text",
      label: "Address",
      modelKey: "address.raw",
      display: true,
    },

    email: {
      displayStyle: "text",
      label: "Email",
      modelKey: "email",
      display: true,
    },

    phone: {
      displayStyle: "text",
      label: "Phone",
      modelKey: "phone",
      display: true,
    },

    homepageUrl: {
      displayStyle: "text",
      label: "Homepage URL",
      modelKey: "homepageUrl",
      display: true,
    },

    advertising: {
      displayStyle: "boolean",
      label: "Advertising",
      modelKey: "advertising",
      display: true,
    },
  },

  editMode: [
    [
      {
        name: "name",
        type: "text",
        label: "Name",
        modelKey: "name",
        width: "60",
      },
      {
        name: "homepageUrl",
        type: "text",
        label: "Homepage URL",
        modelKey: "homepageUrl",
        width: "40",
      },
    ],
    [
      {
        name: "address",
        type: "address",
        label: "Address",
        modelKey: "address",
        type: "address",
        width: "100",
      },
    ],
    [
      {
        name: "email",
        type: "text",
        label: "Email",
        modelKey: "email",
        width: "50",
      },
      {
        name: "phone",
        type: "text",
        label: "Phone",
        modelKey: "phone",
        width: "50",
      },
      {
        name: "advertising",
        type: "single-select-dropdown",
        label: "Advertising",
        modelKey: "advertising",
        width: "30",
        isURLBased: false,
        disableClearable: true,
        formatValue: (value) => (value ? { id: value, label: "Yes" } : { id: false, label: "No" }),
        options: [
          { id: true, label: "Yes" },
          { id: false, label: "No" },
        ],
      },
    ],
  ],
};

export default LAWFIRM_DETAIL_TEMPLATE;
